import type { SyncState } from "../../shared/domain";

const labels: Record<SyncState, string> = {
  device: "Saved on this device",
  waiting: "Waiting for connection",
  syncing: "Syncing",
  synced: "Synced",
  conflict: "Conflict",
  failed: "Could not sync",
  "period-closed": "Server period closed",
};

export function StatusPill({
  state,
  detail,
}: {
  state: SyncState;
  detail?: string;
}) {
  return (
    <span
      className={`status-pill status-pill--${state}`}
      role="status"
      aria-live="polite"
    >
      <i aria-hidden="true" />
      {detail ?? labels[state]}
    </span>
  );
}
